import PropTypes from '~/lib/propTypes'
import styled from '@emotion/styled'
import { space } from '@ticketswap/solar'
import useLoggedInUser from '~/hooks/useLoggedInUser'
import EmailSent from '~/components/EmailSentIllustration'
import { createMarkup } from '~/utils/createMarkup'

const ConfirmMessage = styled.p`
  margin-block-start: 0;
  text-align: center;

  strong {
    display: inline-block;
  }
`

const Illustration = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block-end: ${space[32]};
`

const LoginLinkSent = ({ t }) => {
  const { email } = useLoggedInUser()

  return (
    <>
      <Illustration>
        <EmailSent />
      </Illustration>

      <ConfirmMessage
        dangerouslySetInnerHTML={createMarkup(
          t('common:auth.loginLinkSent.info', {
            email,
          }),
          {
            renderInline: true,
            disableAutolink: true,
          }
        )}
      />
    </>
  )
}

LoginLinkSent.propTypes = {
  t: PropTypes.func.isRequired,
}

export default LoginLinkSent
